import {
  ReportActivitySerie,
  ReportActivitySeriesMap,
} from 'business/shift-report/report-analyze/pages/activity-analyze/types';

export const flattenActivitySeries = (series: ReportActivitySerie[]) => {
  return series.reduce<ReportActivitySeriesMap>((acc, { id, ...rest }) => {
    return {
      ...acc,
      [id]: rest,
    };
  }, {});
};
